// src/oura/ask/SuggestionCard.tsx
//
// Ask Oura (PREVIEW): "approval starts the next job". On a client's Delivery,
// above Next steps, ONLY when the client's own records show answers they
// agreed that no draft has been started from (agreed.ts). One click goes to
// the existing Page workshop; "Not now" hides it for this tab. Nothing is
// written: the Page workshop is where a person starts the drafts.

import type { DeliveryPayload } from "@service/aeo/delivery";
import { cn } from "../lib/cn";
import { PillButton, PillLink, TYPE } from "../ui";
import { agreedKey, agreedLine } from "./agreed";
import { planPageHref } from "./answers";
import { ASK_CARD } from "./AskOura";
import { OuraFace } from "./Mascot";
import { dismiss, useDismissed } from "./store";
import { useAgreedAnswers } from "./useAskData";

export function AskOuraSuggestion({ businessId, delivery }: { businessId: string; delivery: DeliveryPayload | null }) {
    const agreed = useAgreedAnswers(businessId, delivery);
    const id = agreed ? agreedKey(businessId, agreed) : "";
    const hidden = useDismissed(id);
    if (!agreed || hidden) return null;
    return (
        <div className={cn(ASK_CARD, "space-y-3")} data-ask-suggestion>
            <div className="flex items-start gap-3">
                <OuraFace size={24} className="mt-0.5" />
                <div className="min-w-0 flex-1">
                    <p className={cn(TYPE.tc, "m-0 text-[#6B7280]")}>Oura suggests · Preview</p>
                    <p className="m-0 mt-0.5 text-sm font-semibold leading-[22px] text-[#111827]">Start the page drafts</p>
                    <p className="m-0 mt-1 text-sm leading-[22px] text-[#111827]">{agreedLine(agreed)}.</p>
                </div>
            </div>
            <div className="flex flex-wrap items-center gap-2 pl-9">
                <PillLink to={planPageHref(businessId)} variant="primary">
                    Draft them in Page workshop
                </PillLink>
                <PillButton onClick={() => dismiss(id)} className="ring-gray-300">
                    Not now
                </PillButton>
            </div>
        </div>
    );
}
